import { useStudioStore } from "@/store/studio-store";
import { useStudioLocale } from "@/i18n";
import { cn } from "@/lib/utils";
import { BehaviorSurface } from "./behavior-surface";
import { EditorSurface } from "./editor-surface";
import { getEssentialsBuildSurfaceCopy } from "./essentials-build-surface-copy";

/**
 * Tab order + the rail item each tab activates. The LABEL is not here — it is
 * resolved per-locale at render from `essentials-build-surface-copy.ts`, keyed
 * by this same `id`.
 */
const BUILD_VIEWS = [{ id: "editor" }, { id: "behavior" }] as const;

export function EssentialsBuildSurface() {
  const activeRailItem = useStudioStore((state) => state.activeRailItem);
  const setActiveRailItem = useStudioStore((state) => state.setActiveRailItem);
  const activeView = activeRailItem === "behavior" ? "behavior" : "editor";
  const { locale } = useStudioLocale();
  const copy = getEssentialsBuildSurfaceCopy(locale);

  return (
    <div className="flex h-full min-h-0 flex-col">
      <div className="flex h-10 shrink-0 items-center border-b border-border px-3">
        <div
          role="tablist"
          aria-label={copy.buildWorkspace}
          className="flex items-center rounded-md bg-muted p-0.5"
        >
          {BUILD_VIEWS.map((view) => (
            <button
              key={view.id}
              type="button"
              role="tab"
              aria-selected={activeView === view.id}
              className={cn(
                "h-7 rounded px-3 text-xs font-medium transition-colors",
                activeView === view.id
                  ? "bg-background text-foreground shadow-sm"
                  : "text-muted-foreground hover:text-foreground",
              )}
              onClick={() => setActiveRailItem(view.id)}
            >
              {copy[view.id]}
            </button>
          ))}
        </div>
      </div>
      <div className="min-h-0 flex-1">
        {activeView === "behavior" ? <BehaviorSurface /> : <EditorSurface />}
      </div>
    </div>
  );
}
